import { render, staticRenderFns } from "./image_up.vue?vue&type=template&id=0a04c8bd&scoped=true"
import script from "./image_up.vue?vue&type=script&lang=js"
export * from "./image_up.vue?vue&type=script&lang=js"
import style0 from "./image_up.vue?vue&type=style&index=0&id=0a04c8bd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a04c8bd",
  null
  
)

export default component.exports